// aws-config-attachments.js
import AWS from 'aws-sdk';

const s3AttachmentUploader = new AWS.S3({
  accessKeyId: 'AKIAVXGA6A4KTXYGS6V6', // Replace with the new user's Access Key ID
  secretAccessKey: 'cAYBn7DUwH5YA0s0SbmByqCQB+Hg+8dcoaUoG2j+', // Replace with the new user's Secret Access Key
  region: 'ap-southeast-1' // Replace with your S3 bucket's region
});

export default s3AttachmentUploader;
